"use client";

import { CustomCategory } from "@/components/category";
import PodcastPlayButton from "@/components/podcast-play-button";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import Link from "next/link";

type SmallProps = {
  podcast: Content.PodcastEpisode;
};

const Small = (props: SmallProps) => {
  const podcastShow = props.podcast.fields["podcast-show"];
  const title =
    props.podcast.fields.teaserTitle || props.podcast.fields.title;

  return (
    <Link
      href={`/podd/${props.podcast.fields.slug}`}
      className="cursor-pointer group block"
    >
      {podcastShow && (
        <CustomCategory color="Podd" name={podcastShow.fields.title} />
      )}

      {title && <TeaserHeading text={title} />}

      {props.podcast.fields.media?.mediaUrl && (
        <PodcastPlayButton podcast={props.podcast} />
      )}
    </Link>
  );
};

export default Small;
